module.exports = __webpack_public_path__ + "static/mo18-873cef8f35d449126101c6537cff87c2.png";